// Function to calculate and display the delivery date
function calculateDeliveryDate(currentDate = new Date()) {
  // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const dayOfWeek = currentDate.getDay();

  // Define the number of days to delivery based on the day of the week
  // let deliveryDays = 7; // Total days for delivery

  // Check if the day is a weekday (Monday to Friday)
  const deliveryRules = {
    0: 5,  // Sunday
    1: 5,  // Monday 
    2: 6,  // Tuesday | 6 shipping days + 3 not 
    3: 6,  // Wednesday
    4: 7,  // Thursday
    5: 7,  // Friday
    6: 6,  // Saturday
  };
  
  const daysToDelivery = deliveryRules[dayOfWeek];

  console.log('Date: ' + daysToDelivery + ' ' + dayOfWeek);
  
  // Calculate the delivery date considering only weekdays
  const deliveryDate = new Date(currentDate);

  for (let index = 0; index < daysToDelivery; index++) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
    if (deliveryDate.getDay() == 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }
    if (deliveryDate.getDay() == 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    }
  }

  // Define the format options for the delivery date
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  // Format the delivery date as a string
  const formattedDeliveryDate = deliveryDate.toLocaleDateString('en-US', options);

  // Find the element with the class 'delivery-date__to'
  const deliveryDateElement = document.querySelector('.delivery-date__to');
  // If the element exists, set its text content to the formatted delivery date
  if (deliveryDateElement) {
    deliveryDateElement.textContent = formattedDeliveryDate;
  } else {
    // If the element does not exist, log an error message
    console.error('Element with class "delivery-date__to" not found.');
  }
}

// Call the function to calculate and display the delivery date
calculateDeliveryDate(); // For the current date
// calculateDeliveryDate(new Date('09-19-2024')); // For a specific date